export class BodiesForCase {
    bodyvizit_1: string;
    bodyvizit_2: string;
    bodyvizit_1_i: string;
    bodyvizit_2_i: string;
    bodyBirthday_1: string;
    bodyBirthday_2: string;
    bodyBirthday_3: string;
}